import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Meh({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Meh</title>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
      <circle cx="14.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
      <path
        d="M8 15L16 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
